import {useTranslation} from "react-i18next";
import classNames from "classnames";
import styles from "@/elements-react/browse-categories/css/browse-categories.black-and-blue.module.scss";
import {BrowseCategoriesProps, CategoryItem} from "@/elements-react/browse-categories";
import {useMemo} from "preact/hooks";

export const BrowseCategoriesBlackAndBlue: React.FC<BrowseCategoriesProps> = ({
                                                                      categories,
                                                                      className,
                                                                      title,
                                                                      subtitle,
                                                                  }) => {
    const { t } = useTranslation();

    const displayTitle = title || t("browse_categories.title", "Browse by category");
    const displaySubtitle = subtitle || t("browse_categories.subtitle", "Explore our massive inventory across all major automotive systems.");

    const columns = useMemo(() => {
        const cols: CategoryItem[][] = [[], [], [], []];
        categories.forEach((cat, index) => {
            cols[index % 4].push(cat);
        });
        return cols;
    }, [categories]);

    return (
        <div className={classNames(styles.container, className)}>
            <div className={styles.heading}>
                <h2 className={styles.title}>{displayTitle}</h2>
                <div className={styles.subtitle}>{displaySubtitle}</div>
            </div>

            <div className={styles.grid}>
                {columns.map((colItems, colIndex) => (
                    <div key={colIndex} className={styles.column}>
                        {colItems.map((cat) => (
                            <a key={cat.id} href={cat.url} className={styles.categoryLink}>
                                {cat.name}
                            </a>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};